import { colors } from '../tokens';

/** MUI Divider override — uses centralized border default color. */
const MuiDivider = {
  styleOverrides: {
    root: {
      borderColor: colors.border.default,
    },
  },
};

export default MuiDivider;
